import { CommitOptions, DispatchOptions, Module, Store } from "vuex";
import { AuthActions, actions } from "./actions";
import { AuthGetters, getters } from "./getters";
import { AuthMutations, mutations } from "./mutations";
import { AuthState as authState, state } from "./state";
import { State } from "@/store";

export type AuthState = authState;

export type AuthStore<AuthState> = Omit<
  Store<AuthState>,
  "commit" | "getters" | "dispatch"
> & {
  commit<
    K extends keyof AuthMutations,
    P extends Parameters<AuthMutations[K]>[1]
  >(
    key: K,
    payload: P,
    options?: CommitOptions
  ): ReturnType<AuthMutations[K]>;
} & {
  getters: {
    [K in keyof AuthGetters]: ReturnType<AuthGetters[K]>;
  };
} & {
  dispatch<
    K extends keyof AuthActions,
    P extends Parameters<AuthActions[K]>[1]
  >(
    key: K,
    payload: P,
    options?: DispatchOptions
  ): ReturnType<AuthActions[K]>;
};

export const AuthModule: Module<AuthState, State> = {
  state,
  actions,
  mutations,
  getters,
};
